import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { useSelector } from 'react-redux';

import {
    getInitialCompleteDocuments,
    getInitialIncompleteDocuments,
    getInitialTotalDocuments,
} from '../../../../../redux/project/sliceProjectWorkflow';
import { mdiAlertCircle, mdiCheckCircle, mdiChevronDown, mdiInformation } from '@mdi/js';
import Icon from '@mdi/react';
import { headingFontBold, bodyFont, vars } from '../../../../../Theme';
import { useTranslation } from 'react-i18next';
import DocumentRow from '../../_parts/DocumentRow';
import Message from '../../_parts/Message';

const accordionSx = {
    boxShadow: 'none',
    border: `1px solid ${vars.lightGray}`,
    fontSize: '16px',
    mb: '8px !important',
};
const accordionSummarySx = {
    '& .MuiAccordionSummary-content': { m: 0 },
    '& .MuiAccordionSummary-content.Mui-expanded': {
        m: 0,
    },
    fontFamily: headingFontBold,
    py: '8px',
    px: '12px',
    fontSize: '16px',
    m: 0,
    minHeight: '40px',
};

const getInnerAccordionDetailsSx = (hasMessages: boolean) => {
    return {
        fontSize: '14px',
        fontFamily: bodyFont,
        color: vars.font,
        border: 'none',
        p: hasMessages ? '10px 12px' : 0,
    };
};
export default ({ isIncomplete }: { isIncomplete: boolean }) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'initialReleaseDialog' });

    const documents = useSelector(
        isIncomplete ? getInitialIncompleteDocuments : getInitialCompleteDocuments,
    );
    const totalNumberOfDocuments = useSelector(getInitialTotalDocuments);

    if ((isIncomplete && !documents.length) || !documents.length) {
        return <></>;
    }

    return (
        <>
            {isIncomplete && (
                <Message
                    text={t('infoMessage', {
                        numberOfInvalidDocuments: documents?.length,
                        totalNumberOfDocuments: totalNumberOfDocuments,
                    })}
                    icon={mdiInformation}
                />
            )}
            <Box>
                <Accordion disableGutters sx={accordionSx}>
                    <AccordionSummary
                        sx={accordionSummarySx}
                        expandIcon={<Icon path={mdiChevronDown} color={vars.font} size={1} />}
                    >
                        <Message
                            text={`${t(
                                isIncomplete ? 'incompleteDocuments' : 'readyToReleaseDocuments',
                            )} ${documents.length}/${totalNumberOfDocuments}`}
                            icon={isIncomplete ? mdiAlertCircle : mdiCheckCircle}
                            color={isIncomplete ? vars.errorDialogRed : vars.mainGreen}
                            wrapperSx={{ border: 'none', p: 0, m: 0, alignItems: 'center' }}
                            iconWrapperSx={{ display: 'flex', alignItems: 'center' }}
                        />
                    </AccordionSummary>
                    <AccordionDetails sx={{ fontFamily: headingFontBold, p: 0 }}>
                        {documents.map(document => (
                            <Box
                                sx={{ borderTop: `1px solid ${vars.lightGray}` }}
                                key={document.docUnId}
                            >
                                <Accordion disableGutters sx={{ boxShadow: 'none' }}>
                                    <AccordionSummary
                                        sx={{ minHeight: '40px', px: 1.5 }}
                                        expandIcon={
                                            document.messages.length > 0 && (
                                                <Icon
                                                    path={mdiChevronDown}
                                                    color={vars.font}
                                                    size={1}
                                                />
                                            )
                                        }
                                    >
                                        <DocumentRow
                                            document={{
                                                title: document.title,
                                                releasetype: document.releasetype,
                                                universalId: document.docUnId,
                                                errorInfo: document.messages,
                                            }}
                                        />
                                    </AccordionSummary>
                                    <AccordionDetails
                                        sx={getInnerAccordionDetailsSx(
                                            document.messages.length > 0,
                                        )}
                                    >
                                        {document.messages.length > 0 && (
                                            <Box sx={{ fontWeight: 600 }}>
                                                {t('missingInformation')}
                                                <Box sx={{ fontWeight: 400 }}>
                                                    {document.messages.map(message => (
                                                        <li
                                                            style={{ overflowWrap: 'break-word' }}
                                                            key={message}
                                                        >
                                                            {t(message)}
                                                        </li>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        ))}
                    </AccordionDetails>
                </Accordion>
            </Box>
        </>
    );
};
